export interface CreateListBulkReportListItem {
  item_data: Record<string, unknown>;
  ownable_id?: string;
  blacklisted?: boolean;
}

export interface CreateListBulkReportBulkReportInput {
  bulk_report_type: string;
  generated_blob_url?: string;
  metadata?: Record<string, unknown>;
}

export interface CreateListBulkReportParams {
  list_name: string;
  list_items: CreateListBulkReportListItem[];
  bulk_report: CreateListBulkReportBulkReportInput;
}

export interface CreateListBulkReportResponse {
  success: boolean;
  list: Record<string, unknown>;
  list_items: Record<string, unknown>[];
  bulk_report: Record<string, unknown>;
}

export interface ListBulkReportCurrentResponse {
  success: boolean | string;
  bulk_report_type: string;
  status: string;
  bulk_report_id?: number;
  list_code?: string;
  list_name?: string;
  contacts?: unknown[];
}

export type ListBulkReportJobStatus =
  | 'none'
  | 'pending'
  | 'processing'
  | 'completed'
  | 'failed';

export interface BulkReportCsvParams {
  listCode: string;
  bulkReportId: string;
}

export const readBulkReportId = (
  bulkReport: Record<string, unknown> | undefined
): string => {
  if (!bulkReport) {
    return '';
  }
  const id =
    bulkReport.id ?? bulkReport.bulk_report_id ?? bulkReport.bulkReportId;
  return id != null ? String(id) : '';
};

export interface ListBulkReportsIndexResponse {
  success: boolean | string;
  bulk_report_type: string;
  bulk_reports: Record<string, unknown>[];
}
